import {v2 as cloudinary } from 'cloudinary'
import { initializeApp } from 'firebase/app'
import { getFunctions, httpsCallable } from 'firebase/functions'
import { app, model } from '../firebase'

// const app=initializeApp({
//     projectId: "marketplace-2f375",
//     apiKey: "AIzaSyBJQnyjGrmTyF6f2xST7nt-qmHbsF_DNjM",
//     authDomain: "marketplace-2f375.firebaseapp.com"
// })

const functions = getFunctions(app)

// const getCloudinaryKey = httpsCallable(functions, 'getCloudinaryKey')
// const cloudinary_api_key = await getCloudinaryKey()
// const getCloudinarySecret = httpsCallable(functions, 'getCloudinarySecret')
// const cloudinary_api_secret = await getCloudinarySecret()
const deleteCloudinaryImage = httpsCallable(functions, 'deleteCloudinaryImage')
const updateReceiverChats = httpsCallable(functions, 'updateReceiverChats')
const sendNewMessageNotification = httpsCallable(functions, 'sendNewMessageNotification')
const sendNewChatNotification = httpsCallable(functions, 'sendNewChatNotification')
const updateChatroomOnListing = httpsCallable(functions, 'updateChatroomOnListing')

// const cloudinary_api_key = process.env.REACT_APP_CLOUDINARY_API_KEY
// const cloudinary_api_secret = process.env.REACT_APP_CLOUDINARY_API_SECRET

// const cloudinary = require('cloudinary').v2

export const handleUpload = async(uploadFiles) => {
    const imageUrls = []
    for(let i = 0; i < uploadFiles.length; i++) {
        const fd = new FormData()
        fd.append("file", uploadFiles[i])
        fd.append('upload_preset', 'epdquaqb')

        await fetch('https://api.cloudinary.com/v1_1/dhoaj6ygx/upload', {
            method: "POST",
            body: fd,
            headers: {
                'X-Requested-With': 'XMLHttpRequest'
            }
        })
        .then(res => {
            console.log("Uploaded Images to Cloudinary: success")
            return res.json()
        })
        .then(data => {
            console.log(data.secure_url)
            const imageUrl = data.secure_url
            const splitImageUrl = imageUrl.split(".")
            if (splitImageUrl.at(-1) === "heic") {
                //handle unsupported .heic image from ios
                splitImageUrl.pop()
                splitImageUrl.push("jpg")
                const joinedImageUrl = splitImageUrl.join(".")
                imageUrls.push(joinedImageUrl)    
            } else {
                imageUrls.push(data.secure_url)
            }
        })
        .catch(err => {
            console.log("err")
            console.log(err)
        })
    }
    console.log('imageurls', imageUrls)
    return imageUrls
}

// export const handleImageDeletion = async(publicId) => {
//     cloudinary.config({
//         cloud_name: "dhoaj6ygx",
//         api_key: cloudinary_api_key.data + "",
//         api_secret: cloudinary_api_secret.data + "",
//         secure: true
//     })

//     cloudinary.uploader
//     .destroy(publicId)
//     .then(res=>console.log(res))
// }
export const handleImageDeletion = async(publicId) => {
    return await deleteCloudinaryImage(publicId)
}

export const handleUpdateReceiverChats = async(updateObj) => {
    return await updateReceiverChats(updateObj)
}

export const handleNewMessageNotif = async(userId) => {
    return await sendNewMessageNotification(userId)
}

export const handleNewChatNotif = async(userId) => {
    return await sendNewChatNotification(userId)
}

export const handleUpdateChatroomOnListing = async(userId) => {
    return await updateChatroomOnListing(userId)
}

export const getAddressData = async(address) => {
    const addressData = {
        addressComponents: null,
        formattedAddress: null,
        coordinates: null
    }
    if (!address) {
        return addressData
    }
    const formattedAddress = address.replaceAll(" ", "%20")
    const geocodeUrl = `https://maps.googleapis.com/maps/api/geocode/json?address=${formattedAddress}&key=${process.env.REACT_APP_GOOGLE_MAPS_KEY}`
    try {
        const response = await fetch(geocodeUrl,
            {
                method: 'POST',
            }
        )
        const res = await response.json()
        console.log(res.results[0])
        addressData.addressComponents = res.results[0].address_components
        addressData.formattedAddress = res.results[0].formatted_address
        addressData.coordinates = res.results[0].geometry.location
        console.log(addressData)
        return addressData
    } catch (e) {
        console.log(e)
    }
}

export const getZipCode = (addressComponents) => {
    for (const component of addressComponents) {
        if (component.types.includes("postal_code")) {
            return component.short_name
        }
    }
    return null
}

export const getNeighborhood = (addressComponents) => {
    for (const component of addressComponents) {
        if (component.types.includes("neighborhood")) {
            return component.long_name
        }
    }
    return null
}

export const getMarkerCoordinates = (coordinates) => {
    const newCoordinates = {}
    //shift coordinates by up to .003 lat and lng
    newCoordinates.lat = coordinates.lat + ((Math.random() - .5) * 2 * .0025)
    newCoordinates.lng = coordinates.lng + ((Math.random() - .5) * 2 * .0025)
    return newCoordinates
}

async function urlToGenerativePart(url, mimeType) {
    // 1. Fetch the image data from the URL
    const response = await fetch(url);
    
    if (!response.ok) {
        // This could fail due to an invalid URL or a CORS block by the image host
        throw new Error(`Failed to fetch image. Ensure the URL is valid and accessible. Status: ${response.statusText}`);
    }
    
    const blob = await response.blob();
    
    // 2. Convert the Blob to a base64 string
    const base64EncodedDataPromise = new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result.split(',')[1]); // Extracts ONLY the base64 part
        reader.readAsDataURL(blob);
    });

    // 3. Return the structured part object
    return {
        inlineData: { 
            data: await base64EncodedDataPromise, 
            mimeType 
        },
    }
}

export const onAnalyzeImages = async(imageUrls, mimeType = 'image/jpeg') => {
    // Provide a prompt that contains text
    const promptText = "Analyze these images and return ONLY an array of 8 descriptive tags. Do not include any explanation, introductory text, or markdown formatting. Example output format: `[\"tag1\", \"tag2\", \"tag3\"]`"
    const prompt = [promptText]
    
    if (imageUrls.length > 1) {
        for(let i = 0; i <= 1; i++) {
            prompt.push(await urlToGenerativePart(imageUrls[i], mimeType))
        }
    } else {
        prompt.push(await urlToGenerativePart(imageUrls[0], mimeType))
    }
    console.log(prompt)
  
    // To generate text output, call generateContent with the text input
    const result = await model.generateContent(prompt);
  
    const response = result.response;
    const responseText = response.text();
    const tagsArray = JSON.parse(responseText)
    console.log(tagsArray);
    return tagsArray      
}